import V from "@/components/forms/WFileUploadField.module.css";

import { WButton } from "@/components/button/WButton.tsx";
import { FormField } from "@/components/forms/FormField.tsx";
import { DataIcon } from "@/components/icon/DataIcon.tsx";
import { type FileWithSource, FileWithSourceInput } from "@/modules/billing/forms/FileWithSourceInput.tsx";
import { cn } from "@/utils/classNames.ts";
import { type ReactNode, useState } from "react";

// TODO: component to common and be used also in vm image form
export function WFileUploadField({
    value,
    label,
    description,
    onChange,
    headless,
}: {
    value: string;
    label: ReactNode;
    description?: ReactNode;
    onChange: (value: string) => void;
    headless?: boolean;
}) {
    const [file, setFile] = useState<string | undefined>(value);
    const [errorMsg, setErrorMsg] = useState<ReactNode>(undefined);

    function onFieldChange(value: FileWithSource | undefined) {
        if (value) {
            setFile(value.base64Source);
            onChange(value.base64Source);
        }
    }

    function clearField() {
        if (value) {
            setFile(undefined);
            onChange("");
        }
    }

    return (
        <FormField wide label={label} description={description} headless={headless} errorMessage={errorMsg}>
            {file ? (
                <div className="flex gap-0.5em items-center">
                    <div className={V.RadioIcon}>
                        <DataIcon data={file} mode="background" className="size-2.5rem" />
                    </div>

                    <div className={V.RadioIcon}>
                        <DataIcon data={file} mode="mask" className="color-muted size-2.5rem" />
                    </div>

                    <div className={cn(V.RadioIcon, V.selected)}>
                        <DataIcon data={file} mode="mask" className="size-2.5rem" />
                    </div>

                    <WButton
                        action={() => clearField()}
                        size="md"
                        color="default"
                        variant="ghost"
                        ariaLabel="Close"
                        icon="jp-icon-close"
                    />
                </div>
            ) : (
                <FileWithSourceInput
                    acceptedFileTypes={["image/svg"]}
                    maxFileSizeInMB={0.01}
                    onChange={onFieldChange}
                    onSetError={setErrorMsg}
                />
            )}
        </FormField>
    );
}
